export const FEATURE_FLAGS = {
  suggestLocalCurrencyForConverter: 'specs.stores.suggestLocalCurrencyForConverter',
};
